import { memo } from "react";

import Stack from "@mui/material/Stack";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

import ClinicalCrmContextInfoBanner from "../../messageTemplates/components/ClinicalCrmContextInfoBanner";
import type { QuestionnairePayload } from "src-next/modules/questionnaire-builder/form-builder/types";
import AutomationLinkedQuestionnaireItems from "./AutomationLinkedQuestionnaireItems";

export interface AutomationLinkedQuestionnairePreviewProps {
  questionnaire: QuestionnairePayload;
}

const AutomationLinkedQuestionnairePreview = memo(
  ({ questionnaire }: AutomationLinkedQuestionnairePreviewProps) => {
    return (
      <Stack spacing={1.25}>
        <ClinicalCrmContextInfoBanner
          variant="info"
          title="Questionário vinculado"
          icon={<AssignmentOutlinedIcon />}
          description={`Este modelo envia o questionário "${questionnaire.title}" ao paciente.`}
        />
        <AutomationLinkedQuestionnaireItems questionnaire={questionnaire} />
      </Stack>
    );
  },
);

AutomationLinkedQuestionnairePreview.displayName = "AutomationLinkedQuestionnairePreview";

export default AutomationLinkedQuestionnairePreview;
